import Analytics from 'utils/analytics';
import React from 'react';
import { seasonNames } from 'resources/common-values';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';
import CommonStrings from 'resources/common-strings';
import CommonValues from 'resources/common-values';
import HelpBox from 'components/generic/help/index';
import NoProjectionsHelpText from '../no-projections-help-text';
const noStudiesKey = 'NoLinkingStudies';

export default CreateReactClass({
    displayName: 'ComparisonsExpandedProficiency',

    propTypes: {
        proficienciesToDisplay: PropTypes.instanceOf(Immutable.List),
        studentBid: PropTypes.string.isRequired,
        studentFirstName: PropTypes.string.isRequired,
        studentGrade: PropTypes.number.isRequired,
        subjectBid: PropTypes.number.isRequired,
    },

    collegeExplorerLogoClick(e) {
        Analytics.recordButtonClick(CommonValues.SectionIDs.comparisons, 'college-explorer-logo');
    },

    getProjection(study, subjectName) {
        if (study) {
            const seasonNumber = study.get('seasonNumber', null);
            const season = seasonNumber ? seasonNames[seasonNumber].name.toLowerCase() : null;
            const rowkey = study
                .get('study')
                .replaceAll(' ', '-')
                .toLowerCase();
            return (
                <div
                    className="comparisons-projection-row-expanded"
                    key={rowkey}
                    id={`comparisons-projection-row-expanded-${subjectName}-${this.props.studentBid}-${rowkey}`}
                >
                    <div
                        className="projection-category-expanded"
                        id={`projection-category-expanded-${subjectName}-${this.props.studentBid}-${rowkey}`}
                        style={{
                            width: '30%',
                            fontWeight: '600',
                            fontSize: '1.1rem',
                            textAlign: 'center',
                        }}
                    >
                        {study.getIn(['proficiency', 'category'])}
                    </div>
                    <div className="projection-detail-expanded" style={{ width: '60%' }}>
                        <div
                            className="projection-detail-study-expanded"
                            id={`projection-detail-study-expanded-${subjectName}-${this.props.studentBid}-${rowkey}`}
                        >
                            {study.get('studyDisplayName')}
                        </div>
                        <div className="projection-detail-window-expanded">
                            If taken in the{' '}
                            <span
                                className="comparisons-projection-season"
                                id={`comparisons-projection-season-${subjectName}-${this.props.studentBid}-${rowkey}`}
                            >
                                {season}
                            </span>
                        </div>
                        <a
                            className="linking-study-link"
                            key="linking-study-link"
                            href={study.get('url')}
                            target="_blank"
                            id={`comparisons-projection-linking-study-link-${subjectName}-${this.props.studentBid}-${rowkey}`}
                        >
                            {' '}
                            {CommonStrings.comparisonsProjectionsLinkingStudy}{' '}
                        </a>
                    </div>
                </div>
            );
        }
        return null;
    },

    helpText(placeholder) {
        return <NoProjectionsHelpText />;
    },

    getProjections(subjectName) {
        let projections = [];
        if (this.props.proficienciesToDisplay) {
            this.props.proficienciesToDisplay.forEach((proficiency) => {
                projections.push(this.getProjection(proficiency, subjectName));
            });
        }

        if (projections.length === 0) {
            //Push on the empty projections div
            projections.push(
                <div
                    className="comparisons-projections-expanded-no-projections-link no-linking-studies"
                    key={noStudiesKey}
                >
                    {CommonStrings.comparisonsProjectionsNotAvailable}
                    <HelpBox
                        id={'comparisons-projections-expanded-no-linking-studies-' + this.props.studentBid}
                        appLevelCssClassName="show-comparisons-projections-expanded-no-projections"
                        helpContentsRenderer={this.helpText}
                        moduleName={CommonValues.SectionIDs.comparisons}
                        helpLabel="comparisons-projections-expanded-no-projections-help"
                        optionalText="Why?"
                        renderIcon={false}
                    />
                </div>
            );
        } else {
            let hasCollegeStudy = false;
            for (let studyIndex = 0; studyIndex < this.props.proficienciesToDisplay.size; studyIndex++) {
                if (
                    this.props.proficienciesToDisplay.get(studyIndex).get('studyType') ===
                    CommonValues.linkingStudyTypes.collegeLinkingStudy
                ) {
                    hasCollegeStudy = true;
                    break;
                }
            }

            if (!hasCollegeStudy) {
                //If there are no college studies show no projections link
                const rowkey = 'NoCollegeLinkingStudies';
                projections.push(
                    <div
                        className="comparisons-projections-expanded-no-projections-link"
                        key={rowkey}
                        id={`comparisons-projections-expanded-no-projections-link-${subjectName}-${this.props.studentBid}-${rowkey}`}
                    >
                        <HelpBox
                            id={'comparisons-projections-expanded-no-college-linking-studies' + this.props.studentBid}
                            appLevelCssClassName="show-comparisons-projections-expanded-no-projections"
                            helpContentsRenderer={this.helpText}
                            moduleName={CommonValues.SectionIDs.comparisons}
                            helpLabel="comparisons-projections-expanded-no-projections-help"
                            optionalText={CommonStrings.comparisonsProjectionsNotAvailable}
                            renderIcon={false}
                        />
                    </div>
                );
            }
        }

        return projections;
    },

    getCollegeExplorerSection(subjectName) {
        if (
            this.props.studentGrade >= 5 &&
            this.props.studentGrade <= 10 &&
            (this.props.subjectBid === CommonValues.SUBJECT_BID_MATHEMATICS ||
                this.props.subjectBid === CommonValues.SUBJECT_BID_READING)
        ) {
            let collegeExplorerDivs = [];

            const collegeExplorerLogo = require('./images/college-explorer-tool-nwea.jpg');
            const collegeExplorerDescription = CommonStrings.getCollegeExplorerDescription(this.props.studentFirstName);

            collegeExplorerDivs.push(<div className="dividing-line" key="dividing-line"></div>);
            collegeExplorerDivs.push(
                <div
                    className="comparisons-expanded-module-college"
                    key="comparisons-expanded-module-college"
                    id={`comparisons-expanded-module-college-${subjectName}-${this.props.studentBid}`}
                >
                    <div className="comparisons-expanded-module-sub-header">
                        {CommonStrings.comparisonsProjectionsRoadToCollege}
                    </div>
                    <a
                        className="college-explorer-link"
                        id={`college-explorer-link-${subjectName}-${this.props.studentBid}`}
                        href={CommonStrings.comparisonsProjectionsCollegeExplorerLink.target}
                        target="_blank"
                        key="college-explorer-logo"
                    >
                        <img
                            className="college-explorer-logo"
                            id={`college-explorer-logo-${subjectName}-${this.props.studentBid}`}
                            key="college-explorer-logo"
                            src={collegeExplorerLogo}
                            alt="Open College Explorer Tool in a new tab"
                            onClick={this.collegeExplorerLogoClick}
                        />
                    </a>
                    <div
                        className="college-explorer-description"
                        id={`college-explorer-description-${subjectName}-${this.props.studentBid}`}
                    >
                        {collegeExplorerDescription}
                    </div>
                    <a
                        href={CommonStrings.comparisonsProjectionsCollegeExplorerLink.target}
                        target="_blank"
                        key="college-explorer-link"
                    >
                        {CommonStrings.comparisonsProjectionsCollegeExplorerLink.displayText}
                    </a>
                </div>
            );

            return collegeExplorerDivs;
        }
        return null;
    },

    getProjectionsSubHeader(projections) {
        if (!(projections.length === 1 && projections[0].key === noStudiesKey)) {
            return (
                <div className="comparisons-expanded-module-sub-header">
                    {CommonStrings.comparisonsProjectionsProjectedResults}
                </div>
            );
        }
        return null;
    },

    render() {
        const subjectName = CommonValues.getSubjectFieldforBid(this.props.subjectBid, 'shortName');
        const projections = this.getProjections(subjectName);
        const subHeader = this.getProjectionsSubHeader(projections);
        return (
            <div
                className={`comparisons-expanded-projections ${subjectName.toLowerCase()}`}
                id={`comparisons-proficiencies-expanded-${subjectName}-${this.props.studentBid}`}
            >
                <header className="module-header">
                    <h3>PROJECTIONS</h3>
                </header>
                <div className="comparisons-expanded-module-content">
                    <div className={`comparisons-expanded-projections-container ${subjectName.toLowerCase()}`}>
                        <div className="comparisons-expanded-module-projections">
                            {subHeader}
                            {projections}
                        </div>
                        {this.getCollegeExplorerSection(subjectName)}
                    </div>
                </div>
            </div>
        );
    },
});
